<template>
  <div class="login-history" v-loading="loading">
    <div class="page-header">
      <div>
        <h2 class="page-title">登录历史</h2>
        <p class="page-desc">记录每次用户登录尝试（含 IP 与浏览器信息）</p>
      </div>
    </div>

    <div class="toolbar">
      <span class="toolbar-label">用户名</span>
      <el-select
        v-model="filterUsername"
        size="small"
        clearable
        filterable
        placeholder="全部用户"
        style="width: 180px"
        @change="onFilterChange"
      >
        <el-option
          v-for="name in usernames"
          :key="name"
          :label="name"
          :value="name"
        />
      </el-select>

      <el-button type="primary" size="small" :loading="loading" @click="onQueryClick">
        查询
      </el-button>
    </div>

    <div v-if="total != null" class="stats-bar">
      共 {{ total }} 条记录
    </div>

    <el-table v-if="total > 0" :data="rows" style="width: 100%">
      <el-table-column type="index" label="序号" width="70" :index="indexMethod" />
      <el-table-column prop="username" label="用户名" width="120" />
      <el-table-column label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 'success' ? 'success' : 'danger'" size="mini">
            {{ row.status === 'success' ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="登录时间" width="180">
        <template slot-scope="{ row }">
          {{ formatTime(row.loginAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="IP" width="150">
        <template slot-scope="{ row }">
          {{ formatIp(row.ip) }}
        </template>
      </el-table-column>
      <el-table-column prop="userAgent" label="浏览器 / 客户端" min-width="280" show-overflow-tooltip />
      <el-table-column prop="sessionId" label="会话 ID" width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ formatSessionId(row.sessionId) }}
        </template>
      </el-table-column>
    </el-table>

    <div v-else-if="!loading" class="empty-tip">暂无登录记录</div>

    <el-pagination
      v-if="total > 0"
      class="pager"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="page"
      :page-size.sync="pageSize"
      :page-sizes="pageSizeOptions"
      :total="total"
      @current-change="loadLogs"
      @size-change="onPageSizeChange"
    />
  </div>
</template>

<script>
import { fetchLoginLogs } from '../utils/loginLogApi.js'
import { fetchUsers } from '../utils/userApi.js'

export default {
  name: 'LoginHistory',
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      pageSizeOptions: [10, 20, 50, 100],
      filterUsername: '',
      usernames: [],
    }
  },
  async created() {
    await this.loadUsernames()
    await this.loadLogs()
  },
  methods: {
    async loadUsernames() {
      try {
        const users = await fetchUsers()
        this.usernames = users.map(u => u.username)
      } catch {
        this.usernames = []
      }
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    onFilterChange() {
      this.page = 1
      this.loadLogs()
    },
    onQueryClick() {
      this.page = 1
      this.loadLogs()
    },
    onPageSizeChange() {
      this.page = 1
      this.loadLogs()
    },
    async loadLogs() {
      this.loading = true
      try {
        const data = await fetchLoginLogs({
          username: this.filterUsername,
          page: this.page,
          pageSize: this.pageSize,
        })
        this.rows = data.rows || []
        this.total = data.total || 0
        this.page = data.page || this.page
        this.pageSize = data.pageSize || this.pageSize
      } catch (err) {
        this.rows = []
        this.total = 0
        this.$message.error(err.message || '加载登录历史失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(value) {
      if (!value) return '-'
      const normalized = String(value).includes('T') ? value : value.replace(' ', 'T')
      const date = new Date(normalized)
      if (Number.isNaN(date.getTime())) return value
      return date.toLocaleString('zh-CN', { hour12: false })
    },
    formatIp(ip) {
      if (!ip) return '-'
      return String(ip).replace(/^::ffff:/, '')
    },
    formatSessionId(sessionId) {
      if (!sessionId) return '-'
      return `${sessionId.slice(0, 8)}…`
    },
  },
}
</script>

<style scoped>
.page-header {
  margin-bottom: 16px;
  text-align: left;
}

.page-title {
  margin: 0 0 4px;
  font-size: 20px;
  color: #303133;
}

.page-desc {
  margin: 0;
  font-size: 13px;
  color: #909399;
}

.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.toolbar-label {
  font-size: 14px;
  color: #606266;
}

.stats-bar {
  margin-bottom: 12px;
  font-size: 13px;
  color: #606266;
}

.pager {
  margin-top: 16px;
  text-align: right;
}

.empty-tip {
  padding: 24px 0;
  color: #909399;
  text-align: center;
}
</style>
